import * as i0 from "@angular/core";
var PwaService = /** @class */ (function () {
    function PwaService() {
        var _this = this;
        window.addEventListener('beforeinstallprompt', function (event) {
            _this.promptEvent = event;
        });
    }
    PwaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PwaService_Factory() { return new PwaService(); }, token: PwaService, providedIn: "root" });
    return PwaService;
}());
export { PwaService };
